import { render, staticRenderFns } from "./total-card.vue?vue&type=template&id=6c30c861"
import script from "./total-card.vue?vue&type=script&lang=js"
export * from "./total-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports